import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import FormItem from '../../../../components/form/FormItem'
import { MdTitle } from 'react-icons/md'
import { BiX } from 'react-icons/bi'
import { Button, Form } from 'reactstrap'
import { ToSeoUrl } from '../../../../components/general/SeoUrl'
import DragDropFiles from '../../../../components/form/DragDropFiles'
import { fetchModuleGet } from '../../../../redux/slices/moduleGetSlice'
import { fetchModuleCreate } from '../../../../redux/slices/moduleCreateSlice'
import { fetchModuleUpdate } from '../../../../redux/slices/moduleUpdateSlice'
import CkItem from '../../../../components/form/CkItem'

const CrudShowcaseItemPage = ({ showMenu, setShowMenu, setChanged, setSelectedItem, selectedItem, t, id }) => {
    const [formData, setFormData] = useState({ files: [], filesTR: [], filesEN: [] })
    const dispatch = useDispatch()

    const getData = async () => {
        if (selectedItem !== 0) {
            var data = await dispatch(fetchModuleGet({ id: selectedItem }))
            if (data.payload) {
                setFormData({
                    files: data.payload?.files,
                    titletr: data.payload?.title["tr"] || "",
                    titleen: data.payload?.title["en"] || "",
                    slugtr: data.payload?.slug["tr"] || "",
                    slugen: data.payload?.slug["en"] || "",
                    contenttr: data.payload?.content["tr"] || "",
                    contenten: data.payload?.content["en"] || "",
                    descriptiontr: data.payload?.description["tr"] || "",
                    descriptionen: data.payload?.description["en"] || "",
                    specialField1tr: data.payload?.specialField1["tr"] || "",
                    specialField1en: data.payload?.specialField1["en"] || "",
                })
                if (data?.payload?.files && data?.payload?.filesLang) {
                    const langMap = {};
                    data.payload.filesLang.forEach(obj => {
                        const key = Object.keys(obj)[0];
                        const value = Object.values(obj)[0];
                        const originalKey = key.split('/').pop().split('.')[0].split('-')[0];
                        langMap[originalKey] = value;
                    });

                    const filesTR = [];
                    const filesEN = [];

                    data.payload.files.forEach(filePath => {
                        const originalName = filePath.split('/').pop().split('.')[0].split('-')[0];
                        const lang = langMap[originalName];

                        if (lang === "tr") {
                            filesTR.push({ file: filePath, lang: "tr" });
                        } else if (lang === "en") {
                            filesEN.push({ file: filePath, lang: "en" });
                        }
                    });

                    setFormData(prev => ({ ...prev, filesTR, filesEN }));
                }
            }
        }
    }

    const closeModal = () => {
        setFormData({ files: [], filesTR: [], filesEN: [], slugtr: "", slugen: "", titletr: "", titleen: "", descriptiontr: "", descriptionen: "", contenttr: "", contenten: "", specialField1tr: "", specialField1en: "" })
        setShowMenu(!showMenu)
        setSelectedItem(0)
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        const title = { "tr": formData.titletr, "en": formData.titleen }
        const slug = { "tr": ToSeoUrl(formData.titletr), "en": ToSeoUrl(formData.titleen) }
        const description = { "tr": formData.descriptiontr, "en": formData.descriptionen }
        const content = { "tr": formData.contenttr, "en": formData.contenten }
        const specialField1 = { "tr": formData.specialField1tr, "en": formData.specialField1en }

        const allFiles = [
            ...(formData?.filesTR || []).map(f => ({ ...f, lang: 'tr' })),
            ...(formData?.filesEN || []).map(f => ({ ...f, lang: 'en' }))
        ];

        let Files = allFiles.map(f => f.file || f);
        var FilesLang = allFiles
            .map(f => {
                const fileName = typeof f.file === "string" ? f.file : f.file?.name;
                return { [fileName]: f.lang };
            });
        var FilesTitle = allFiles.map(f => f.title || '');

        var filesToKeep = Files
            .filter(file => typeof file === 'string' || !file.file)
            .map(file => typeof file === 'string' ? file : file.preview);

        Files = Files.filter(f => typeof f.file !== "string");

        await dispatch(
            selectedItem === 0 ?
                fetchModuleCreate({
                    file: Files,
                    filesLang: FilesLang,
                    filesTitle: FilesTitle,
                    showcaseID: id,
                    slug: slug,
                    title: title,
                    description: description,
                    content: content,
                    specialField1: specialField1
                }) :
                fetchModuleUpdate({
                    id: selectedItem,
                    showcaseID: id,
                    file: Files,
                    filesLang: FilesLang,
                    filesTitle: FilesTitle,
                    slug: slug,
                    title: title,
                    description: description,
                    content: content,
                    specialField1: specialField1,
                    filesToKeep: filesToKeep
                })
        )
        closeModal()
        setChanged(true)
        getData()
        setShowMenu(false)
    }

    useEffect(() => { getData() }, [dispatch, selectedItem])

    return (
        <div className={showMenu ? 'right-popup' : 'd-none'}>
            <div className='right-popup-close' onClick={closeModal}><BiX size={24} /></div>
            <div className='right-popup-menu'>
                <div className='mb-3 text-center'><h5>{t(selectedItem === 0 ? "add_item" : "edit_item")}</h5></div>
                <Form onSubmit={handleSubmit}>
                    <DragDropFiles
                        formData={{ ...formData, filesTR: formData.filesTR }}
                        name="filesTR"
                        setFormData={setFormData}
                        selectedItem={selectedItem}
                        title={`${t("images")} (TR)`}
                    />
                    <DragDropFiles
                        formData={{ ...formData, filesEN: formData.filesEN }}
                        name="filesEN"
                        setFormData={setFormData}
                        selectedItem={selectedItem}
                        title={`${t("images")} (EN)`}
                    />
                    <FormItem
                        id={`titletr`}
                        name={`titletr`}
                        type="text"
                        icon={<MdTitle size={20} />}
                        title={`${t("title")} (TR)`}
                        formData={formData}
                        setFormData={setFormData}
                        keyT='titletr'
                    />
                    <FormItem
                        id={`titleen`}
                        name={`titleen`}
                        type="text"
                        icon={<MdTitle size={20} />}
                        title={`${t("title")} (EN)`}
                        formData={formData}
                        setFormData={setFormData}
                        keyT='titleen'
                    />
                    <FormItem
                        id={`descriptiontr`}
                        name={`descriptiontr`}
                        type="text"
                        icon={<MdTitle size={20} />}
                        title={`${t("subtitle")} (TR)`}
                        formData={formData}
                        setFormData={setFormData}
                        keyT='descriptiontr'
                    />
                    <FormItem
                        id={`descriptionen`}
                        name={`descriptionen`}
                        type="text"
                        icon={<MdTitle size={20} />}
                        title={`${t("subtitle")} (EN)`}
                        formData={formData}
                        setFormData={setFormData}
                        keyT='descriptionen'
                    />
                    <FormItem
                        id={`specialField1tr`}
                        name={`specialField1tr`}
                        type="text"
                        icon={<MdTitle size={20} />}
                        title={`${t("other_field")} (TR)`}
                        formData={formData}
                        setFormData={setFormData}
                        keyT='specialField1tr'
                    />
                    <FormItem
                        id={`specialField1en`}
                        name={`specialField1en`}
                        type="text"
                        icon={<MdTitle size={20} />}
                        title={`${t("other_field")} (EN)`}
                        formData={formData}
                        setFormData={setFormData}
                        keyT='specialField1en'
                    />
                    <CkItem
                        formData={formData}
                        setFormData={setFormData}
                        keyT='contenttr'
                        title={`${t("content")} (TR)`}
                    />
                    <CkItem
                        formData={formData}
                        setFormData={setFormData}
                        keyT='contenten'
                        title={`${t("content")} (EN)`}
                    />

                    <div className='d-flex justify-content-end mt-4 w-100'>
                        <Button type='submit' color={selectedItem === 0 ? 'primary' : 'warning'} className="text-white">
                            {t(selectedItem === 0 ? "add" : "edit")}
                        </Button>
                    </div>
                </Form>
            </div>
        </div>
    )
}

export default CrudShowcaseItemPage